export class Favorites {
    /**
     * Interface that defines the structure of the Unprocessed Notifications
     */
    idComponent: number;
    username: string;
}
export class FavoritesComponent {
    /**
     * Interface that defines the structure of the Unprocessed Notifications
     */
    componentName: string;
    favoriteName: string;
	id: number;
	applicationName: string;
	componentDescription: string;
	componentUrl: string;
}

export class FavoritesMenu {
    /**
     * Interface that defines the structure of the Unprocessed Notifications
     */
	title: string;
	root: boolean;
	faIcon:string;
	page: string;
	submenu: Array<FavoritesSubMenu> =[];
    id: number;
}

export class FavoritesSubMenu {
    /**
     * Interface that defines the structure of the Unprocessed Notifications
     */
	title: string;
	page: string;
	faIcon:string;
	icon:string;
	submenuIcon: boolean;
    id: number;
}



